export default __webpack_public_path__ + "static/media/history.fc39bdea.svg";